import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { WorkloadDialogComponent } from './workload-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';


@NgModule({
  declarations: [
    WorkloadDialogComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule
  ]
})
export class WorkloadDialogModule {
}
